import { Control, useWatch } from 'react-hook-form';

import { validateDrawAmount } from '@consumer-frontend/nc-utils';

export type RequestCashAdvanceFormT = {
  requestedDrawAmount?: number;
};

export type UseRequestedDrawPreviewPropsT = {
  control?: Control<RequestCashAdvanceFormT>;
  maxDrawAmount?: number;
  minDrawAmount?: number;
};

// Invalid/cleared amounts preview as $0 rather than stale or undefined.
export const useRequestedDrawPreview = ({
  control,
  maxDrawAmount,
  minDrawAmount,
}: UseRequestedDrawPreviewPropsT): number => {
  const requestedDrawAmount = useWatch<RequestCashAdvanceFormT, 'requestedDrawAmount'>({
    control,
    name: 'requestedDrawAmount',
  });

  if (requestedDrawAmount === undefined || validateDrawAmount(requestedDrawAmount, minDrawAmount, maxDrawAmount) !== true) {
    return 0;
  }

  return requestedDrawAmount;
};
